/**
 * ACORDE — Búsqueda:
 * 1. Las "búsquedas populares" buscan al tocarlas, como si el cliente las escribiera.
 * 2. Sugerencias instantáneas mientras se escribe: notas, familias y marcas que empiezan por lo
 *    escrito, con su ilustración. Salen del índice que deja la pantalla de inicio en la página
 *    (<script data-acorde-indice>), no de Shopify, por eso aparecen desde la segunda letra.
 */
const MAXIMO_POR_TIPO = 4;

function normalizar(texto) {
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

function leerIndice() {
  const nodo = document.querySelector('[data-acorde-indice]');
  if (!nodo) return null;
  try {
    return JSON.parse(nodo.textContent);
  } catch {
    return null;
  }
}

function resaltar(nombre, consulta) {
  const inicio = normalizar(nombre).indexOf(consulta);
  if (inicio < 0) return nombre;
  const fin = inicio + consulta.length;
  return `${nombre.slice(0, inicio)}<mark>${nombre.slice(inicio, fin)}</mark>${nombre.slice(fin)}`;
}

function coincidencias(lista, consulta) {
  const empiezan = [];
  const contienen = [];
  for (const item of lista) {
    const nombre = normalizar(item.nombre);
    if (nombre.startsWith(consulta)) empiezan.push(item);
    else if (nombre.split(' ').some((palabra) => palabra.startsWith(consulta))) contienen.push(item);
  }
  return [...empiezan, ...contienen].slice(0, MAXIMO_POR_TIPO);
}

class SugerenciasAcorde {
  constructor(componente) {
    this.componente = componente;
    this.campo = componente.querySelector('input[type="search"], input[name="q"]');
    this.indice = leerIndice();
    if (!this.campo || !this.indice) return;

    this.contenedor = document.createElement('div');
    this.contenedor.className = 'acorde-busqueda-sugerencias';
    this.contenedor.hidden = true;
    const cabecera = componente.querySelector('.predictive-search-form__header');
    (cabecera || this.campo.closest('form')).insertAdjacentElement('afterend', this.contenedor);

    this.campo.addEventListener('input', () => this.actualizar());
    this.campo.addEventListener('search', () => this.actualizar());
  }

  actualizar() {
    const consulta = normalizar(this.campo.value);
    if (consulta.length < 2) {
      this.contenedor.hidden = true;
      this.contenedor.replaceChildren();
      this.componente.removeAttribute('data-acorde-con-sugerencias');
      return;
    }

    const grupos = [
      ['notas', this.indice.notas],
      ['familias', this.indice.familias],
      ['marcas', this.indice.marcas],
    ];
    const fragmento = document.createDocumentFragment();
    for (const [tipo, lista] of grupos) {
      for (const item of coincidencias(lista || [], consulta)) {
        const chip = document.createElement('a');
        chip.className = 'acorde-busqueda-sugerencias__chip';
        chip.href = item.url;
        if (item.imagen) {
          const imagen = document.createElement('img');
          imagen.className = 'acorde-busqueda-sugerencias__imagen';
          imagen.src = item.imagen;
          imagen.alt = '';
          imagen.width = 24;
          imagen.height = 24;
          chip.appendChild(imagen);
        }
        const texto = document.createElement('span');
        texto.innerHTML = resaltar(item.nombre, consulta);
        chip.appendChild(texto);
        const etiqueta = document.createElement('span');
        etiqueta.className = 'acorde-busqueda-sugerencias__tipo';
        etiqueta.textContent = this.indice.textos?.[tipo] || tipo;
        chip.appendChild(etiqueta);
        fragmento.appendChild(chip);
      }
    }

    this.contenedor.replaceChildren(fragmento);
    const haySugerencias = this.contenedor.childElementCount > 0;
    this.contenedor.hidden = !haySugerencias;
    // Con sugerencias a la vista no tiene sentido el aviso «no se encontró ningún resultado»
    this.componente.toggleAttribute('data-acorde-con-sugerencias', haySugerencias);
  }
}

// Chips de búsquedas populares
document.addEventListener('click', (evento) => {
  const chip = evento.target.closest('[data-acorde-buscar]');
  if (!chip) return;
  const componente = chip.closest('predictive-search-component');
  const campo = componente?.querySelector('input[type="search"], input[name="q"]');
  if (!campo) return;
  campo.value = chip.dataset.acordeBuscar;
  campo.focus();
  campo.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: campo.value }));
});

// Sugerencias instantáneas en cada búsqueda predictiva de la página
for (const componente of document.querySelectorAll('predictive-search-component')) {
  if (!componente.dataset.acordeSugerencias) {
    componente.dataset.acordeSugerencias = 'true';
    new SugerenciasAcorde(componente);
  }
}
